export const WASTE_TYPE_OTHER = 'other';

export const WASTE_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'cardboard', label: 'Cardboard' },
  { value: 'paper', label: 'Paper' },
  { value: 'plastic', label: 'Plastic' },
  { value: 'metal', label: 'Metal' },
  { value: 'glass', label: 'Glass' },
  { value: 'organic', label: 'Organic' },
  { value: 'e_waste', label: 'E-waste' },
  { value: 'hazardous', label: 'Hazardous' },
  { value: 'wood', label: 'Wood' },
  { value: 'textile', label: 'Textile' },
  { value: 'construction_demolition', label: 'Construction and demolition' },
  { value: 'medical', label: 'Medical waste' },
  { value: 'oil', label: 'Oil / lubricants' },
];
